import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PwaDetectionService {

  public isPWA(): boolean {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isIosStandalone = (window.navigator as any).standalone === true;
    const isFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;

    return isStandalone || isIosStandalone || isFullscreen;
  }

 // return true if pwa, false if browser
  public isAccessAllowed(): boolean {
    const isPwa = this.isPWA();
    console.log('PWA Check:', isPwa);
    return isPwa;
  }
}
